import React from 'react'

import { classNames } from '@lib/simpleFn'
import QuestionAndChoices from '@components/QuestionAndChoices'
import ScoreBoard from '@components/ScoreBoard'

type QuestionAreaType = {
  questionIds: number[]
  fontSize?: string
  viewResultMode: boolean
  isDelivery?: boolean
}
export default function QuestionArea({
  questionIds,
  fontSize,
  viewResultMode,
  isDelivery,
}: QuestionAreaType) {
  let fontClassName = 'text-[18px] sm:text-[20px]'
  if (fontSize === 'small') fontClassName = 'text-[18px] sm:text-[16px]'
  if (fontSize === 'large') fontClassName = 'text-[18px] sm:text-[25px]'

  return (
    <div className={'pb-[240px] sm:pb-0 px-5 sm:px-[100px]'}>
      {viewResultMode && !isDelivery && <ScoreBoard />}
      <div
        className={classNames(
          'flex max-h-full w-full max-w-[1024px] lg:max-w-full h-full py-5 sm:py-0 overflow-auto sm:justify-center',
          fontClassName
        )}
      >
        {questionIds.map((id, i) => {
          const questionAndChoices = []
          if (i > 0)
            questionAndChoices.push(
              <div className={'border-eaeaea border min-h-[calc(100vh-160px)]'} />
            )
          questionAndChoices.push(
            <QuestionAndChoices questionId={id} isDelivery={isDelivery} key={i} />
          )
          return questionAndChoices
        })}
      </div>
    </div>
  )
}
